/* unplugin-vue-components disabled */import { render } from "./ScoreView.vue?vue&type=template&id=52060d1c&scoped=true"
import script from "./ScoreView.vue?vue&type=script&lang=js"
export * from "./ScoreView.vue?vue&type=script&lang=js"

import "./ScoreView.vue?vue&type=style&index=0&id=52060d1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52060d1c"]])

export default __exports__